module.exports = __webpack_public_path__ + "static/media/30OIOS5.152e79ea.jpg";